import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import InfoAPI from './InfoAPI';
import { getSessionNameFromUrl } from '../utils/Functions';

const Chat = ({ sessionName, height = 50 }) => {
    const [channelName, setChannelName] = useState(null);
    const [embedTW, setEmbedTW] = useState(false);

    useEffect(() => {
        const getChannelName = async () => {
            try {
                const bodyData = JSON.stringify({
                    'request_type': 'info',
                    'info_type': 'getsettings',
                    'session_name': getSessionNameFromUrl()
                });
                const jsonData = await InfoAPI(bodyData);
                const result = JSON.parse(jsonData.body);
                const embeddingVarTW = result.TW_embed_bool;
                if (embeddingVarTW==0) {
                    setEmbedTW(false);
                }
                else {
                    setEmbedTW(true);
                }
                setChannelName(result.TW_channel_name);
            } catch (error) {
                console.error('Error fetching channel name:', error);
            }
        }
        getChannelName();
    }, [sessionName]);

    return (
        <>
            {embedTW && channelName && (
                <Row className="justify-content-center mb-3">
                    <Col xs={12} md={8} lg={6}>
                        <iframe
                            src={`https://www.twitch.tv/embed/${channelName}/chat?parent=${window.location.hostname}`}
                            height={`${height}vh`}
                            width="100%"
                            style={{
                                border: '1px solid rgba(255, 255, 255, 0.2)',
                                borderRadius: '0.5rem',
                                backgroundColor: 'rgba(0, 0, 0, 0.2)'
                            }}
                        />
                    </Col>
                </Row>
            )}
        </>
    );
};

export default Chat;